// extracted by mini-css-extract-plugin
module.exports = {"grid":"index-module--grid--5M-sY","sticky":"index-module--sticky--3azWq","tabs":"index-module--tabs--1Tu2_"};